export default "__VITE_ASSET__CRHnuK1Q__"